// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bodyRow__NGcsd {
  background: var(--tables-main-surface);
}
.bodyRow__NGcsd:hover td {
  border-bottom: 1px solid var(--tables-primary-row-stroke);
  background: var(--tables-primary-row-surface-hover);
}
.bodyRow__NGcsd td {
  padding: 10px 25px;
  color: var(--tables-primary-row-text-main);
  border-bottom: 1px solid var(--tables-primary-row-stroke);
  background: var(--tables-primary-row-surface-default);
  letter-spacing: 0.01em;
  white-space: normal;
  font-size: 14px;
  line-height: 20px;
  text-align: right;
}
@media (max-width: 980px) {
  .bodyRow__NGcsd td {
    padding: 10px 15px;
  }
}
@media (max-width: 860px) {
  .bodyRow__NGcsd td {
    font-size: 12px;
    padding: 10px;
  }
}

.dateColumn__hqBxO {
  text-align: left !important;
}

.iconColumn__yedBS {
  cursor: pointer;
}
.iconColumn__yedBS path {
  stroke: var(--tables-primary-row-icon);
}

.expandRowIcon__VFBrw {
  outline: none;
  transition: all 0.3s ease-in-out;
}

.expandRowIconTop__C_qfG {
  transform: rotate(180deg);
}

.skeletonText__jKpuE {
  height: 16px;
}

.skeletonIcon__c_8oo {
  width: 16px;
  height: 16px;
}`, "",{"version":3,"sources":["webpack://./../src/pages/CostSavingsDetails/components/ExpandedRow/style.module.scss"],"names":[],"mappings":"AA0EA;EACE,sCAAA;AAzEF;AA2EE;EACE,yDAAA;EACA,mDAAA;AAzEJ;AA4EE;EACE,kBAAA;EACA,0CAAA;EACA,yDAAA;EACA,qDAAA;EACA,sBAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;EACA,iBAAA;AA1EJ;AA4EI;EAXF;IAYI,kBAAA;EAzEJ;AACF;AA2EI;EAfF;IAgBI,eAAA;IACA,aAAA;EAxEJ;AACF;;AA4EA;EACE,2BAAA;AAzEF;;AA4EA;EACE,eAAA;AAzEF;AA2EE;EACE,sCAAA;AAzEJ;;AA6EA;EACE,aAAA;EACA,gCAAA;AA1EF;;AA6EA;EACE,yBAAA;AA1EF;;AA6EA;EACE,YAAA;AA1EF;;AA6EA;EACE,WAAA;EACA,YAAA;AA1EF","sourcesContent":["%scrollbar-style {\n  scrollbar-color: rgba(0, 0, 0, 0.2) rgba(0, 0, 0, 0.05);\n  scrollbar-width: auto;\n\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n@mixin scrollBar {\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n\n@mixin ellipsis-text {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n}\n\n@mixin tooltip {\n  padding: 8px !important;\n  opacity: 1 !important;\n  filter: drop-shadow(0 0 1px rgba(12, 26, 75, 0.24));\n  border-radius: 4px !important;\n  text-align: left !important;\n}\n\n@mixin modalTitle {\n  color: var(--header-title-main);\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n  text-transform: uppercase;\n}\n\n.bodyRow {\n  background: var(--tables-main-surface);\n  \n  &:hover td {\n    border-bottom: 1px solid var(--tables-primary-row-stroke);\n    background: var(--tables-primary-row-surface-hover);\n  }\n\n  td {\n    padding: 10px 25px;\n    color: var(--tables-primary-row-text-main);\n    border-bottom: 1px solid var(--tables-primary-row-stroke);\n    background: var(--tables-primary-row-surface-default);\n    letter-spacing: 0.01em;\n    white-space: normal;\n    font-size: 14px;\n    line-height: 20px;\n    text-align: right;\n\n    @media (max-width: 980px) {\n      padding: 10px 15px;\n    }\n\n    @media (max-width: 860px) {\n      font-size: 12px;\n      padding: 10px;\n    }\n  }\n}\n\n.dateColumn {\n  text-align: left !important;\n}\n\n.iconColumn {\n  cursor: pointer;\n\n  path {\n    stroke: var(--tables-primary-row-icon);\n  }\n}\n\n.expandRowIcon {\n  outline: none;\n  transition: all 0.3s ease-in-out;\n}\n\n.expandRowIconTop {\n  transform: rotate(180deg);\n}\n\n.skeletonText {\n  height: 16px;\n}\n\n.skeletonIcon {\n  width: 16px;\n  height: 16px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"bodyRow": `bodyRow__NGcsd`,
	"dateColumn": `dateColumn__hqBxO`,
	"iconColumn": `iconColumn__yedBS`,
	"expandRowIcon": `expandRowIcon__VFBrw`,
	"expandRowIconTop": `expandRowIconTop__C_qfG`,
	"skeletonText": `skeletonText__jKpuE`,
	"skeletonIcon": `skeletonIcon__c_8oo`
};
module.exports = ___CSS_LOADER_EXPORT___;
